import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { adminApi } from '../../../utils/endpoints/adminApi';
import { handleApiRejection } from '../../../utils/lib';

import http from '../../../services/http';

export const activateUserAction = createAction('admin/activateUser');
export const deactivateUserAction = createAction('admin/deactivateUser');
export const getUsersAction = createAction('admin/getUsers');
export const getDashboardAction = createAction('admin/getDashboard');
export const reassignUserAction = createAction('admin/reassignUser');
export const createUserAction = createAction('admin/createUser');
export const getAllCertificatesAction = createAction('admin/getAllCertificates');

export const activateUser = createAsyncThunk(activateUserAction.type, async (userId) => {
    const response = await http.put(adminApi.activateUser(userId));
    return response.data;
});

export const deactivateUser = createAsyncThunk(deactivateUserAction.type, async (userId) => {
    const response = await http.put(adminApi.deactivateUser(userId));
    return response.data;
});

export const getUsersList = createAsyncThunk(getUsersAction.type, async () => {
    const response = await http.get(adminApi.getAllUsers);
    return response.data;
});

export const getDashboardOverview = createAsyncThunk(getDashboardAction.type, async () => {
    const response = await http.get(adminApi.getDashboard);
    return response.data;
});

export const getAllCertificates = createAsyncThunk(getAllCertificatesAction.type, async (status) => {
    const response = await http.get(adminApi.getAllCertificates(status));
    return response.data;
});

export const reassignUser = createAsyncThunk(reassignUserAction.type, async ({ user_id, role_id }, thunkApi) => {
    try {
        const response = await http.put(adminApi.reassign(user_id), { role_id });
        return response.data;
   } catch (error) {
        return thunkApi.rejectWithValue(handleApiRejection(error));
   }
});

export const createUser = createAsyncThunk(createUserAction.type, async (payload, thunkApi) => {
   try {
        const response = await http.post(adminApi.create, payload);
        return response.data;
   } catch (error) {
        return thunkApi.rejectWithValue(handleApiRejection(error));
   }
});

